const syncCardsData = [
    {
      step: 'step 1',
      title: 'Navigate to HubSpot',
      text: 'Open HubSpot and navigate to the \'Companies\' section by clicking on the button below to find the company you wish to update, or create a new one',
    },
    {
      step: 'step 2',
      title: 'Locate the functionality',
      text: 'This is located on the right-hand side in the panel with other functionalities and is called \'Enrich company info\'.',
    },
    {
      step: 'step 3',
      title: 'Synchronise company',
      text: 'Click on the \'Sync with Company.info\' button and select a company from the search results. The company will now be updated with the latest information based on your search.',
    },
    {
      step: '(Optional)',
      title: 'Re-synchronise company',
      text: 'If a company is synced, you can choose to re-sync it by clicking on the \'actions\' button and then selecting \'resync company\' to enter another search.',
    },
    {
      step: '(Optional)',
      title: 'Update company',
      text: 'By clicking on the \'update company\' button, it will fetch the latest information and update your synced company accordingly',
    },
  ];

export default syncCardsData;



